import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import SystemUpdateIcon from '@mui/icons-material/SystemUpdate';
import { usePWA } from '../../hooks/usePWA';

/**
 * Prompts user to update when new version is available
 */

export function UpdatePrompt() {
  const { updateAvailable, updateServiceWorker } = usePWA();
  const [showPrompt, setShowPrompt] = React.useState(false);

  React.useEffect(() => {
    if (updateAvailable) {
      setShowPrompt(true);
    }
  }, [updateAvailable]);

  const handleUpdate = () => {
    updateServiceWorker();
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
  };

  return (
    <Snackbar
      open={showPrompt}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 70, sm: 24 } }}
    >
      <Alert
        severity="info"
        icon={<SystemUpdateIcon />}
        action={
          <Button size="small" color="inherit" onClick={handleUpdate}>
            更新
          </Button>
        }
        onClose={handleDismiss}
        sx={{
          width: '100%',
          maxWidth: 400,
        }}
      >
        发现新版本，点击更新以获得最新功能
      </Alert>
    </Snackbar>
  );
}
